var React = require('react');

function Poland (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"16","height":"10","fill":"#F3F3F3","key":0}),React.createElement("rect",{"width":"16","height":"5","fill":"#dc143c","y":"5","key":1})]);
}

Poland.defaultProps = {"width":"1280","height":"800","id":"Flag of Poland","viewBox":"0 0 16 10"};

module.exports = Poland;

Poland.default = Poland;
